window.Products.Clothing.DrapedKimono = function() {
};
window.Products.Clothing.DrapedKimono.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.DrapedKimono.id = 44;
window.Products.Clothing.DrapedKimono.slug = 'draped-kimono';
window.Products.Clothing.DrapedKimono.has_3d = true;
window.Products.Clothing.DrapedKimono.dpi = 150;

window.Products.Clothing.DrapedKimono.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = -1.5;
	modelViewer.setFixedView('front');
	if(!modelViewer.inlab){
		modelViewer.enableAutoRotate(0.5);
	}
};

window.Products.Clothing.DrapedKimono.prototype.setThreeControls = function(controls) {
	controls.minDistance = 2.8;
	controls.maxDistance = 3.6;
};

window.Products.Clothing.DrapedKimono.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material[0].map = modelViewer.texture;
	modelViewer.object.children[0].material[1].map = modelViewer.texture;
};